import React from 'react';

export default function Component(props) {

  const { question, answersList, ansNPSInput, surveyScreenData, surveyLanguageCode } = props;
  let [showValue2, handleValue2] = React.useState(111)
  let showValue = false;

  function CustomLabels(optionID, optionName, question) {
    let surveyLanguageCode = "customNPS";
    return (surveyLanguageCode !== '') ?
      (question && question.transl &&
        question.transl[surveyLanguageCode] &&
        question.transl[surveyLanguageCode][optionID]) ?
        question.transl[surveyLanguageCode][optionID] : optionName
      : optionName
  }

  function NPSName(optionID, optionName, surveyLanguageCode, question) {
    return (surveyLanguageCode !== '') ?
      (question && question.transl &&
        question.transl[surveyLanguageCode] &&
        question.transl[surveyLanguageCode].optionsList &&
        question.transl[surveyLanguageCode].optionsList[optionID]) ?
        question.transl[surveyLanguageCode].optionsList[optionID] : optionName
      : optionName
  }

  function NPSColor(question, surveyLanguageCode, isSelected) {

    let Color = "#a3a3a3";
    let Name = NPSName("Ratehere", "Rate here", surveyLanguageCode, question)
    // let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
    let answer = ""
    if (answersList && answersList.length > 0) {
      let getIndex1 = answersList.findIndex(item => item.questionId === question.id)
      if (getIndex1 !== -1) {
        answer = answersList && answersList[getIndex1] && answersList[getIndex1]["answer"] ? parseInt(answersList[getIndex1]["answer"]) : ""
      }
    }

    if (showValue || showValue === 0) {
      answer = showValue;
    }

    if (answer === 0 || answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6) {
      Color = "#E91E63";
      if (answer === 0 || answer === 1 || answer === 2) {
        Name = NPSName("Extremelydissatisfied", CustomLabels("Extremelydissatisfied", "Extremely dissatisfied", question), surveyLanguageCode, question)
      }
      else if (answer === 3 || answer === 4) {
        Name = NPSName("Dissatisfied", CustomLabels("Dissatisfied", "Dissatisfied", question), surveyLanguageCode, question)
        console.log('Dissatisfied Name: ', Name)
      }
      else if (answer === 5 || answer === 6) {
        Name = NPSName("Neither", CustomLabels("Neither", "Neither", question), surveyLanguageCode, question)
      }
    }
    else if (answer === 7) {
      Color = "#E91E63";
      Name = NPSName("Satisfied", CustomLabels("Satisfied", "Satisfied", question), surveyLanguageCode, question)
    }
    else if (answer === 8 || answer === 9 || answer === 10) {
      Color = "#E91E63";
      Name = NPSName("Extremelysatisfied", CustomLabels("Extremelysatisfied", "Extremely Satisfied", question), surveyLanguageCode, question)
    }

    const textColor = isSelected
      ? surveyScreenData?.optionTextActiveColor || "#FFFFFF"
      : surveyScreenData?.optionTextColor || "#FFFFFF";

    const bgColor = isSelected
      ? surveyScreenData?.optionBgActiveColor || "#5ACC66"
      : surveyScreenData?.optionBgColor || "#3B92D4";

    const borderColor = isSelected
      ? surveyScreenData?.optionBorderActiveColor || "#5ACC66"
      : surveyScreenData?.optionBorderColor || "#3B92D4";


    return {
      textColor: textColor,
      bgColor: bgColor,
      borderColor: borderColor,
      name: Name
    }
  }

  function NPSColor2(question) {



    let Color = "#a3a3a3";
    let Name = NPSName("Ratehere", "Rate here", surveyLanguageCode, question)
    let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
    if (showValue2 || showValue2 === 0) {
      answer = showValue2;
    }


    if (answer === 0 || answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6) {
      Color = "#E91E63";
      if (answer === 0 || answer === 1 || answer === 2) {
        Name = NPSName("Extremelydissatisfied", CustomLabels("Extremelydissatisfied", "Extremely dissatisfied", question), surveyLanguageCode, question)
      }
      else if (answer === 3 || answer === 4) {
        Name = NPSName("Dissatisfied", CustomLabels("Dissatisfied", "Dissatisfied", question), surveyLanguageCode, question)
        console.log('Dissatisfied Name: ', Name)
      }
      else if (answer === 5 || answer === 6) {
        Name = NPSName("Neither", CustomLabels("Neither", "Neither", question), surveyLanguageCode, question)
      }
    }
    else if (answer === 7) {
      Color = "#E91E63";
      Name = NPSName("Satisfied", CustomLabels("Satisfied", "Satisfied", question), surveyLanguageCode, question)
    }
    else if (answer === 8 || answer === 9 || answer === 10) {
      Color = "#E91E63";
      Name = NPSName("Extremelysatisfied", CustomLabels("Extremelysatisfied", "Extremely Satisfied", question), surveyLanguageCode, question)
    }

    return {
      color: Color,
      name: Name
    }
  }

  function matchAnswer(answersList1, question1) {
    let value = "";
    if (answersList1 && answersList1.length > 0) {
      let getIndex1 = answersList1.findIndex(item => item.questionId === question1.id);
      if (getIndex1 !== -1) {
        value = answersList1 && answersList1[getIndex1] && answersList1[getIndex1].answer ? answersList1[getIndex1].answer : "";
      }
    }
    return value
  }


  return (
    <>
      <div className="grid grid-cols-11 md:gap-4 gap-2 py-6  lg:text-lg text-sm mx-2">
        {/* 1 */}
        {[...Array(11).keys()].map((value, index) =>
          <>
            {((value).toString() === matchAnswer(answersList, question)) ?

              <span onMouseEnter={() => handleValue2((value))} onClick={() => ansNPSInput((value).toString(), question)} key={index}
                style={{ background: NPSColor(question, surveyLanguageCode, true).bgColor, color: NPSColor(question, surveyLanguageCode, true).textColor, borderColor: NPSColor(question, surveyLanguageCode, true).borderColor }}
                className="bg-white rounded-md md:p-4 md:py-4 p-4 py-2 text-white border flex items-center justify-center font-medium cursor-pointer px-3">
                {value}
              </span>
              :
              <>
                {(value) <= (showValue || parseInt(matchAnswer(answersList, question))) ?
                  <span onMouseEnter={() => handleValue2((value))} onClick={() => ansNPSInput((value).toString(), question)} key={index}
                    style={{ background: NPSColor(question, surveyLanguageCode, true).bgColor, color: NPSColor(question, surveyLanguageCode, true).textColor, borderColor: NPSColor(question, surveyLanguageCode, true).borderColor }}
                    className="bg-white rounded-md md:p-4 md:py-4 p-4 py-2 text-white border border-[#E91E63] flex items-center justify-center font-medium cursor-pointer px-3">
                    {value}
                  </span>
                  :
                  <span onMouseEnter={() => handleValue2((value))} onClick={() => ansNPSInput((value).toString(), question)} key={index}
                    style={{ background: NPSColor(question, surveyLanguageCode, false).bgColor, color: NPSColor(question, surveyLanguageCode, false).textColor, borderColor: NPSColor(question, surveyLanguageCode, false).borderColor }}
                    className="bg-white rounded-md md:p-4 md:py-4 p-4 py-2 flex items-center border border-[#212121] justify-center hover:bg-gray-100 font-medium cursor-pointer px-3">
                    {value}
                  </span>
                }
              </>
            }
          </>
        )}

      </div>


      <div
        className="text-gray-700 font-semibold text-center mb-2 rounded-sm py-1 mx-2">{NPSColor2(question, surveyLanguageCode).name}</div>

      {/* <div className="flex justify-between">
            <span className="italic text-gray-500 text-sm px-4">{NPSName("Extremelydissatisfied", "1 = not so great", surveyLanguageCode, question)}</span>
            <span className="italic text-gray-500 text-sm px-4">{NPSName("Extremelysatisfied", "10 = great", surveyLanguageCode, question)}</span>
          </div> */}
      {/* <div style={{background:NPSColor(question,surveyLanguageCode).color}} 
          className="bg-red-500 text-white text-center mb-2 rounded-sm py-1 mx-2">{NPSColor(question,surveyLanguageCode).name}</div> */}


    </>
  );
}